import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { IAccountDomainService } from '../../account';
import { IDocMetaDomainService } from '../../doc-meta';
import { IUserInfoDomainService } from '../../user-info';
import { networkRequest } from '@tencent/ark-request';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { report } from '@tencent/ark-utils/lib/report/tam';
import { UserAgent } from '@tencent/docs-user-agent';
import { CGI_LIKE, CGI_LIKE_BANNED, CGI_LIKE_COUNT, CGI_LIKE_ENABLE_SET, CGI_LIKE_ICON, CGI_LIKE_LIST, } from './cgi-path';
import { SetLikeEnableActionReport, SetLikeEnableEventCodeReport, SetLikeEnableReport, SetLikeEnableTitleBarReport, SetLikeEnableVer5Report, SetLikeEnableVipStatusReport, } from './report';
/**
 * 点赞列表暂时不处理分页，默认按照 100 请求
 */
var DEFAULT_PAGE_SIZE = 100;
var ua = new UserAgent();
var getCgiUrlWithXSRF = function (url) { return "".concat(url).concat(~url.indexOf('?') ? '&' : '?', "xsrf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)); };
var LikeRepo = /** @class */ (function () {
    function LikeRepo(docMetaDomain, userInfoDomainService, accountDomainService) {
        this.docMetaDomain = docMetaDomain;
        this.userInfoDomainService = userInfoDomainService;
        this.accountDomainService = accountDomainService;
    }
    /**
     * 对文档点赞
     */
    LikeRepo.prototype.like = function (fileId, iconId) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    file_id: fileId,
                    icon_id: iconId,
                };
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE), req)];
            });
        });
    };
    /**
     * 获取支持的点赞类型。
     */
    LikeRepo.prototype.getLikeIconList = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    offset: 0,
                    limit: DEFAULT_PAGE_SIZE,
                };
                if (fileId) {
                    req = {
                        offset: 0,
                        limit: DEFAULT_PAGE_SIZE,
                        file_id: fileId,
                    };
                }
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE_ICON), req)];
            });
        });
    };
    /**
     * 设置点赞打开/关闭接口
     */
    LikeRepo.prototype.setLikeEnable = function (fileId, enable) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, vip, svip, svipPlus, reportVer5, req;
            return __generator(this, function (_b) {
                _a = this.accountDomainService.accountAggregate.vipInfo, vip = _a.vip, svip = _a.svip, svipPlus = _a.svipPlus;
                reportVer5 = (function () {
                    if (svipPlus.status === SetLikeEnableVipStatusReport.VIP_ON) {
                        return SetLikeEnableVer5Report.SUPER_VIP_PLUS_USER;
                    }
                    if (svip.status === SetLikeEnableVipStatusReport.VIP_ON) {
                        return SetLikeEnableVer5Report.SUPER_VIP_USER;
                    }
                    if (vip.status === SetLikeEnableVipStatusReport.VIP_ON) {
                        return SetLikeEnableVer5Report.VIP_USER;
                    }
                    return SetLikeEnableVer5Report.NO_VIP_USER;
                })();
                report({
                    opername: SetLikeEnableReport.OPERATION_NAME,
                    module: SetLikeEnableReport.MODULE,
                    action: enable ? SetLikeEnableActionReport.ON : SetLikeEnableActionReport.OFF,
                    eventcode: enable ? SetLikeEnableEventCodeReport.DOC_VIP_LIKE_SWITCH_ON
                        : SetLikeEnableEventCodeReport.DOC_VIP_LIKE_SWITCH_OFF,
                    // 判断是否超级会员还是普通会员
                    ver5: reportVer5,
                    ver8: ua.isPC ? SetLikeEnableTitleBarReport.PC_TITLEBAR : SetLikeEnableTitleBarReport.MOBILE_TITLEBAR,
                });
                req = {
                    enable: enable,
                    file_id: fileId,
                };
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE_ENABLE_SET), req)];
            });
        });
    };
    /**
     * 是否禁止点赞接口（单文档灰度判断）
     */
    LikeRepo.prototype.isBanned = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    file_id: fileId,
                };
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE_BANNED), req)];
            });
        });
    };
    /**
     * 获取文档的点赞总数
     */
    LikeRepo.prototype.getLikeRecordCount = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    file_id: fileId,
                };
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE_COUNT), req)];
            });
        });
    };
    /**
     * 获取点赞列表
     */
    LikeRepo.prototype.getLikeRecordList = function (fileId, from, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = {
                    file_id: fileId,
                    start_record_id: from,
                    limit: limit,
                    is_desc: true,
                };
                return [2 /*return*/, networkRequest.post(getCgiUrlWithXSRF(CGI_LIKE_LIST), req)];
            });
        });
    };
    LikeRepo = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, IUserInfoDomainService),
        __param(2, IAccountDomainService),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], LikeRepo);
    return LikeRepo;
}());
export { LikeRepo };
